import { useId } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Field } from "@/shared/forms";

interface ExactnessCheckboxProps<ExactnessValue = any> {
    className?: string;
    ariaLabel?: string;
    name: string;
    inputValue: string;
    dataTestId?: string;
    show?: boolean;
    isExactFn?: (exactnessValue: ExactnessValue) => boolean;
    onToggleExact?: (value: ExactnessValue) => void;
}

export function ExactnessCheckbox<ExactnessValue>({
    className,
    name,
    ariaLabel,
    inputValue,
    show,
    dataTestId,
    isExactFn,
    onToggleExact,
}: ExactnessCheckboxProps<ExactnessValue>) {
    const id = useId();
    const { t } = useTranslation();
    // TODO: once migration to new folder structure will be finished, return back to matchAllTerms
    // const { updatePath } = useExactnessPath({
    //     name,
    //     exactnessStrategy: ExactnessStrategy.Default,
    // });

    const showExactnessCheckbox = show && inputValue?.length > 0;

    return (
        <div className={classNames(className, { noDisplay: !showExactnessCheckbox })} key={id}>
            <Field name={name}>
                {(field) => {
                    if (!showExactnessCheckbox) return null;
                    const { onChange: fieldOnChange, ...fieldProps } = field;
                    return (
                        <div className="indent">
                            <input
                                id={id}
                                aria-label={ariaLabel}
                                data-testid={dataTestId}
                                className="checkbox"
                                type="checkbox"
                                checked={isExactFn ? isExactFn(field.value) : field.value}
                                onChange={() => {
                                    if (onToggleExact) {
                                        onToggleExact(field.value as ExactnessValue);
                                    } else {
                                        fieldOnChange(!field.value);
                                    }
                                }}
                                {...fieldProps}
                            />
                            <label htmlFor={id} className="SFS_mb-6">
                                {t("exactText")}
                            </label>
                        </div>
                    );
                }}
            </Field>
        </div>
    );
}
